// Import SVG icons directly
import clothingIcon from '../assets/icons/repoze_icon_category-clothing.svg';
import shoesIcon from '../assets/icons/repoze_icon_category-shoes.svg';
import accessoriesIcon from '../assets/icons/repoze_icon_category-accessories.svg';
import uniformsIcon from '../assets/icons/repoze_icon_category-uniforms.svg';
import sportingIcon from '../assets/icons/repoze_icon_category-sporting.svg';
import instrumentsIcon from '../assets/icons/repoze_icon_category-instruments.svg';
import toysIcon from '../assets/icons/repoze_icon_category-toys.svg';
import hobbiesIcon from '../assets/icons/repoze_icon_category-hobbies.svg';
import booksIcon from '../assets/icons/repoze_icon_category-books.svg';
import technologyIcon from '../assets/icons/repoze_icon_category-technology.svg';
import bundlesIcon from '../assets/icons/repoze_icon_category-bundles.svg';

/**
 * Category data configuration for the CategoryPanel
 * Maps the categories shown in the UI to their corresponding icons and search parameters
 */
export const categoryData = [
  { id: 'clothing', title: 'Clothing', icon: clothingIcon, src: '/s?pub_categoryLevel1=clothing' },
  { id: 'footwear', title: 'Footwear', icon: shoesIcon, src: '/s?pub_categoryLevel1=footwear' },
  { id: 'accessories', title: 'Accessories', icon: accessoriesIcon, src: '/s?pub_categoryLevel1=accessories' },
  { id: 'uniforms', title: 'School', icon: uniformsIcon, src: '/s?pub_categoryLevel1=school-uniforms-and-supplies' },
  { id: 'sporting', title: 'Sportswear', icon: sportingIcon, src: '/s?pub_categoryLevel1=sportswear-club-uniforms' },
  { id: 'instruments', title: 'Toys', icon: instrumentsIcon, src: '/s?pub_categoryLevel1=toys-and-play' },
  // { id: 'toys', title: 'Toys', icon: toysIcon, src: '/s?pub_categoryLevel1=toys' },
  // { id: 'hobby', title: 'Hobby', icon: hobbiesIcon, src: '/s?pub_categoryLevel1=hobby' },
  // { id: 'books', title: 'Books', icon: booksIcon, src: '/s?pub_categoryLevel1=books' },
  // { id: 'technology', title: 'Technology', icon: technologyIcon, src: '/s?pub_categoryLevel1=technology' },
  // { id: 'bundles', title: 'Bundles', icon: bundlesIcon, src: '/s?pub_categoryLevel1=bundles' },
];

export default categoryData;
